import React, { useState } from 'react';
import { Building2, Map, FileText, Scale, AlertCircle, TrendingUp, TrendingDown, Minus, MapPin, PlusCircle } from 'lucide-react';
import { LegalFilingsModal } from './LegalFilingsModal';
export function DetailsTab() {
  const [legalTab, setLegalTab] = useState('ALL');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFilingIndex, setSelectedFilingIndex] = useState(0);
  const handleOpenModal = (index: number) => {
    setSelectedFilingIndex(index);
    setIsModalOpen(true);
  };
  return <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-742">
      {/* Company Details - 3 Column Layout */}
      <div className="grid grid-cols-3 gap-6" data-id="element-743">
        {/* Registration */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-744">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-745">Registration</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs" data-id="element-746">
            <div data-id="element-747">
              <p className="font-semibold text-gray-900" data-id="element-748">SOS State</p>
              <p className="text-gray-600" data-id="element-749">PA</p>
            </div>
            <div data-id="element-750">
              <p className="font-semibold text-gray-900" data-id="element-751">Founded Date</p>
              <p className="text-gray-600" data-id="element-752">1949</p>
            </div>
            <div data-id="element-753">
              <p className="font-semibold text-gray-900" data-id="element-754">SOS Number</p>
              <p className="text-gray-600" data-id="element-755">8675309</p>
            </div>
            <div data-id="element-756">
              <p className="font-semibold text-gray-900" data-id="element-757">Type</p>
              <p className="text-gray-600" data-id="element-758">S-Corporation</p>
            </div>
            <div data-id="element-759">
              <p className="font-semibold text-gray-900" data-id="element-760">TIN Number</p>
              <p className="text-gray-600" data-id="element-761">23-1984726</p>
            </div>
            <div data-id="element-762">
              <p className="font-semibold text-gray-900" data-id="element-763">DBAs</p>
              <p className="text-gray-600" data-id="element-764">DUNDER MIFFLIN</p>
            </div>
            <div data-id="element-765">
              <p className="font-semibold text-gray-900" data-id="element-766">Domestic / Foreign</p>
              <p className="text-gray-600" data-id="element-767">Domestic</p>
            </div>
            <div data-id="element-768">
              <p className="font-semibold text-gray-900" data-id="element-769">Entity Type</p>
              <p className="text-gray-600" data-id="element-770">Private Subsidiary</p>
            </div>
          </div>
        </div>

        {/* Information */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-771">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-772">Information</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs mb-3" data-id="element-773">
            <div data-id="element-774">
              <p className="font-semibold text-gray-900" data-id="element-775">SIC</p>
              <p className="text-gray-600" data-id="element-776">5112 - PAPER & OFFICE SUPPLIES</p>
            </div>
            <div data-id="element-777">
              <p className="font-semibold text-gray-900" data-id="element-778">Ticker</p>
              <p className="text-gray-600" data-id="element-779">--</p>
            </div>
            <div data-id="element-780">
              <p className="font-semibold text-gray-900" data-id="element-781">NAICS</p>
              <p className="text-gray-600" data-id="element-782">
                424120 - STATIONERY AND OFFICE SUPPLIES
              </p>
            </div>
            <div data-id="element-783">
              <p className="font-semibold text-gray-900" data-id="element-784">Approximate Revenue</p>
              <p className="text-gray-600" data-id="element-785">~$48 Million</p>
            </div>
          </div>
          <div className="text-xs" data-id="element-786">
            <p className="font-semibold text-gray-900 mb-0.5" data-id="element-787">Description</p>
            <p className="text-gray-600 line-clamp-3" data-id="element-788">
              Dunder Mifflin Inc. provides paper and office supplies to small
              businesses. With a mid-size market focus, we pride ourselves on
              customer service that big box stores can't match. "Limitless paper
              in a paperless world."
            </p>
            <button className="text-indigo-600 hover:text-indigo-700 font-medium mt-1" data-id="element-789">
              More
            </button>
          </div>
        </div>

        {/* Location */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 flex flex-col" data-id="element-790">
          <div className="flex justify-between items-start mb-2" data-id="element-791">
            <h3 className="text-sm font-bold text-gray-900" data-id="element-792">Location</h3>
            <Map className="w-4 h-4 text-indigo-600" data-id="element-793" />
          </div>
          <div className="text-xs text-gray-600 mb-2" data-id="element-794">
            <p data-id="element-795">1725 SLOUGH AVENUE, SUITE 200</p>
            <p data-id="element-796">SCRANTON, PA 18503, US</p>
          </div>
          <div className="flex-1 bg-gray-100 rounded-lg border border-gray-200 overflow-hidden max-h-[150px]" data-id="element-797">
            <img src="https://cdn.magicpatterns.com/uploads/wvsUfBV1167d45Ehi9LHfe/scrantonbusinesspark2.jpg" alt="Dunder Mifflin Office - Scranton Business Park" className="w-full h-full object-contain bg-gray-50" data-id="element-798" />
          </div>
        </div>
      </div>

      {/* Legal Filings */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-799">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50/50" data-id="element-800">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-801">Legal Filings (4)</h3>
          <div className="flex bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden text-sm font-medium" data-id="element-802">
            {['ALL', 'LAWSUITS', 'LIENS', 'UCC', 'BANKRUPTCY'].map(tab => <button key={tab} onClick={() => setLegalTab(tab)} className={`px-4 py-2 border-r border-gray-200 last:border-r-0 flex items-center gap-2 transition-colors ${legalTab === tab ? 'bg-gray-100 text-gray-900' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'}`} data-id="element-803">
                {tab === 'LAWSUITS' && <Scale className="w-4 h-4" data-id="element-804" />}
                {tab === 'LIENS' && <FileText className="w-4 h-4" data-id="element-805" />}
                {tab === 'UCC' && <Building2 className="w-4 h-4" data-id="element-806" />}
                {tab === 'BANKRUPTCY' && <AlertCircle className="w-4 h-4" data-id="element-807" />}
                {tab}
              </button>)}
          </div>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-808">
          {(legalTab === 'ALL' || legalTab === 'LIENS') && <button onClick={() => handleOpenModal(0)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-809">
              <div className="flex items-center gap-4" data-id="element-810">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-811">
                  <FileText className="w-5 h-5 text-gray-500" data-id="element-812" />
                </div>
                <div className="text-left" data-id="element-813">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-814">
                    <h4 className="font-bold text-gray-900" data-id="element-815">
                      LACKAWANNA COUNTY RECORDER
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-green-500" title="Released" data-id="element-816"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-817">
                    STATE TAX LIEN • RELEASED
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-818">
                <p className="font-medium text-gray-900" data-id="element-819">4/25/2016</p>
                <p className="text-sm text-gray-500" data-id="element-820">$1,118</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'LAWSUITS') && <div className="p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-821">
              <div className="flex items-center gap-4" data-id="element-822">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-823">
                  <Scale className="w-5 h-5 text-gray-500" data-id="element-824" />
                </div>
                <div data-id="element-825">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-826">
                    <h4 className="font-bold text-gray-900" data-id="element-827">
                      LEVINSON V. DUNDER MIFFLIN INC.
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-yellow-500" title="Settled" data-id="element-828"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-829">
                    CIVIL LAWSUIT • WRONGFUL TERMINATION • SETTLED
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-830">
                <p className="font-medium text-gray-900" data-id="element-831">8/14/2008</p>
                <p className="text-sm text-gray-500" data-id="element-832">Undisclosed</p>
              </div>
            </div>}

          {(legalTab === 'ALL' || legalTab === 'UCC') && <button onClick={() => handleOpenModal(1)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-833">
              <div className="flex items-center gap-4" data-id="element-834">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-835">
                  <Building2 className="w-5 h-5 text-gray-500" data-id="element-836" />
                </div>
                <div className="text-left" data-id="element-837">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-838">
                    <h4 className="font-bold text-gray-900" data-id="element-839">
                      DE LAGE LANDEN FINANCIAL SERVICES
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-blue-500" title="Active" data-id="element-840"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-841">
                    UCC FILING • EQUIPMENT LEASE (COPIERS)
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-842">
                <p className="font-medium text-gray-900" data-id="element-843">2/14/2023</p>
                <p className="text-sm text-gray-500" data-id="element-844">Active</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'BANKRUPTCY') && <button onClick={() => handleOpenModal(2)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-845">
              <div className="flex items-center gap-4" data-id="element-846">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-847">
                  <AlertCircle className="w-5 h-5 text-gray-500" data-id="element-848" />
                </div>
                <div className="text-left" data-id="element-849">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-850">
                    <h4 className="font-bold text-gray-900" data-id="element-851">
                      SWIDLER BERLIN SHEREFF FRIEDMAN LLP
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-gray-400" title="Dismissed" data-id="element-852"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-853">
                    CHAPTER 7 FILING (INVOLUNTARY) • DISMISSED
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-854">
                <p className="font-medium text-gray-900" data-id="element-855">6/15/2019</p>
                <p className="text-sm text-gray-500" data-id="element-856">Dismissed</p>
              </div>
            </button>}
        </div>
      </div>

      {/* News */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-857">
        <div className="p-5 border-b border-gray-200" data-id="element-858">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-859">News</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-860">
          <table className="w-full text-sm text-left" data-id="element-861">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-862">
              <tr data-id="element-863">
                <th className="px-5 py-3 font-medium" data-id="element-864">Date</th>
                <th className="px-5 py-3 font-medium" data-id="element-865">Title</th>
                <th className="px-5 py-3 font-medium" data-id="element-866">Sentiment</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-867">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-868">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-869">
                  Mar 15, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-870">
                  Scranton Branch Reports Record Breaking Sales Quarter, Led by
                  Top Salesman Dwight Schrute
                </td>
                <td className="px-5 py-4" data-id="element-871">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-872">
                    <TrendingUp className="w-3.5 h-3.5" data-id="element-873" />
                    Positive
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-874">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-875">
                  Feb 28, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-876">
                  Scranton Branch Wins Regional Sales Excellence Award for
                  Outstanding Customer Service and Innovation
                </td>
                <td className="px-5 py-4" data-id="element-877">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-878">
                    <TrendingUp className="w-3.5 h-3.5" data-id="element-879" />
                    Positive
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-880">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-881">
                  Jan 12, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-882">
                  New 'Dunder Mifflin Infinity' Platform Exceeds Expectations,
                  Online Orders Up 45% in First Quarter
                </td>
                <td className="px-5 py-4" data-id="element-883">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-884">
                    <TrendingUp className="w-3.5 h-3.5" data-id="element-885" />
                    Positive
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-886">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-887">
                  Nov 05, 2025
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-888">
                  Former Temp Arrested for Corporate Fraud, Scranton Branch
                  Manager Declares "I Knew It"
                </td>
                <td className="px-5 py-4" data-id="element-889">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700 border border-gray-200" data-id="element-890">
                    <Minus className="w-3.5 h-3.5" data-id="element-891" />
                    Neutral
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Affiliated Companies */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-892">
        <div className="p-5 border-b border-gray-200" data-id="element-893">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-894">
            Affiliated Companies
          </h3>
        </div>
        <div className="overflow-x-auto" data-id="element-895">
          <table className="w-full text-sm text-left" data-id="element-896">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-897">
              <tr data-id="element-898">
                <th className="px-5 py-3 font-medium" data-id="element-899">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-900">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-901">Country</th>
                <th className="px-5 py-3 font-medium w-12" data-id="element-902"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-903">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-904">
                <td className="px-5 py-3 text-indigo-600" data-id="element-905">ENERVATE INC.</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-906">Ultimate Parent</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-907">US</td>
                <td className="px-5 py-3" data-id="element-908">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-909">
                    Monitored
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-910">
                <td className="px-5 py-3 text-indigo-600" data-id="element-911">SABRE CORPORATION</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-912">Immediate Parent</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-913">US</td>
                <td className="px-5 py-3" data-id="element-914">
                  <PlusCircle className="w-5 h-5 text-indigo-500 cursor-pointer hover:text-indigo-700 transition-colors" data-id="element-915" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Branch Offices */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-916">
        <div className="p-5 border-b border-gray-200" data-id="element-917">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-918">Branch Offices</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-919">
          <table className="w-full text-sm text-left" data-id="element-920">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-921">
              <tr data-id="element-922">
                <th className="px-5 py-3 font-medium" data-id="element-923">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-924">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-925">Address</th>
                <th className="px-5 py-3 font-medium" data-id="element-926">Country</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-927">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-928">
                <td className="px-5 py-3 text-gray-900" data-id="element-929">
                  DUNDER MIFFLIN SCRANTON
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-930">
                  Headquarters / Branch
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-931">
                  1725 Slough Ave, Scranton, PA 18503
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-932">US</td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-933">
                <td className="px-5 py-3 text-gray-900" data-id="element-934">
                  DUNDER MIFFLIN AKRON
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-935">Branch Office</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-936">
                  400 Market St, Akron, OH 44308
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-937">US</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {isModalOpen && <LegalFilingsModal onClose={() => setIsModalOpen(false)} initialIndex={selectedFilingIndex} data-id="element-938" />}
    </div>;
}